'use client';

import * as React from 'react';
import { Moon, Sun, Monitor } from 'lucide-react';
import { useTheme } from 'next-themes';

import { Button } from '@/components/ui/button';

const ORDER = ['light', 'dark', 'system'] as const;
type Theme = (typeof ORDER)[number];

const ICONS: Record<Theme, React.ComponentType<{ className?: string }>> = {
  light: Sun,
  dark: Moon,
  system: Monitor,
};

const LABELS: Record<Theme, string> = {
  light: 'Light theme',
  dark: 'Dark theme',
  system: 'System theme',
};

export function ThemeToggle(): JSX.Element {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => setMounted(true), []);

  const current: Theme = mounted && (theme === 'light' || theme === 'dark' || theme === 'system')
    ? theme
    : 'system';
  const Icon = ICONS[current];

  function cycle(): void {
    const idx = ORDER.indexOf(current);
    setTheme(ORDER[(idx + 1) % ORDER.length] ?? 'system');
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={cycle}
      aria-label={`Switch theme (current: ${LABELS[current]})`}
      title={LABELS[current]}
    >
      <Icon className="h-5 w-5" />
    </Button>
  );
}
